import React, {Component} from 'react';
import {connect} from 'react-redux';
import cn from 'classnames';
import debounce from 'lodash/debounce';
import {mergeClassNames} from '../../utils/utilsGlobal';
import services from '../../services/services';
import originalStyles from './MessageSearch.scss';

const mapStateToProps = state => {
  return {
    messages: state.messages
  };
};

@connect(mapStateToProps)
export class MessageSearch extends Component {
  
  constructor(props) {
    super(props);
    
    this.state = {
      searchText: '',
      // id сообщений, которые совпадают с текстом поиска
      searchMessagesIds: [],
      // id сообщений
      messagesIds: [],
      // номер отображаемого сообщения
      showMessageNumber: 0,
      // всего сообщений
      totalMessageCount: 0
    };
  
    this.input = React.createRef();
  }
  
  debouncedTriggerSearch = debounce(this.getEntryTextPoint.bind(this), 400);
  
  componentDidUpdate(prevProps) {
    const {messages, show} = this.props;
    
    if (show && !prevProps.show) {
      this.input.current?.focus();
      this.setState({searchText: ''});
    }
    
    if (messages !== prevProps.messages) {
      const ids = messages.map(el => el.id);
      this.setState({messagesIds: ids});
    }
  }
  
  handleChange = (event) => {
    const {value} = event.target;
    this.setState({searchText: value});
    if (!value) {
      this.props.onChangeText('');
      this.props.onChangeSearchMessagesIds([]);
      this.clearSearchResult();
    }
    this.debouncedTriggerSearch(value);
  }
  
  /**
   * Переход по результатам поиска с использованием стрелочек.
   * @param event
   */
  keyPress = (event) => {
    const { keyCode } = event;
    const arrowDirection = [38, 40];
    const escCode = 27;
    const enterCode = 13;
    
    if (keyCode === enterCode && this.state.searchMessagesIds[0]) {
      this.props.onScroll(this.state.searchMessagesIds[0]);
    }
  
    if (keyCode === escCode) {
      this.handleCloseSearch();
    }
    
    if (!arrowDirection.includes(keyCode)) {
      return;
    }
    event.preventDefault();
    
    const {showMessageNumber, totalMessageCount} = this.state;
    const disabledPrevBtn = !(totalMessageCount && showMessageNumber < totalMessageCount);
    const disabledNextBtn = !(totalMessageCount && showMessageNumber > 1);
    
    if (keyCode === 38 && !disabledPrevBtn) { // up arrow
      this.showPrevMessage();
    } else if (keyCode === 40 && !disabledNextBtn ) { // down arrow
      this.showNextMessage();
    }
  }
  
  /**
   * Получение всех сообщений с текстом запроса
   */
  getEntryTextPoint(value) {
    const normalizedSearchTerm = value.trim();
    if (this.state.searchText !== normalizedSearchTerm) {
      this.setState({searchText: normalizedSearchTerm});
    }
    
    if (!normalizedSearchTerm) {
      return;
    }
    
    services.messageSubscription.getMessageBySearch(normalizedSearchTerm).then(resp => {
      const ids = [];
      
      if (resp.length) {
        resp.forEach(el => {
          ids.push(el.node.id);
        });
        
        const lastFindMessageId = ids[0];
  
        this.setState({
          totalMessageCount: resp.length,
          showMessageNumber: 1,
          searchMessagesIds: ids
        });
  
        if (this.state.messagesIds.includes(lastFindMessageId)) {
          this.props.onScroll(lastFindMessageId);
        } else {
          this.loadPrevMessages(lastFindMessageId, 'up');
        }
        
      } else {
        this.setState({
          totalMessageCount: 0,
          showMessageNumber: 1,
          searchMessagesIds: []
        });
      }
      
      this.props.onChangeText(this.state.searchText);
      this.props.onChangeSearchMessagesIds(ids);
    })
  }
  
  clearSearchResult = () => {
    this.setState({showMessageNumber: 0, totalMessageCount: 0, searchMessagesIds: [], searchText: ''});
    this.props.onChangeText('');
    this.props.onChangeSearchMessagesIds([]);
  }
  
  
  /**
   * Переход к предыдущему сообщению
   */
  showPrevMessage = () => {
    const {showMessageNumber} = this.state;
    const messageId = this.state.searchMessagesIds[showMessageNumber];
    this.setState({showMessageNumber: showMessageNumber + 1});
    this.loadMessageLogic(messageId, 'up');
  }
  
  /**
   * Переход к следующему сообщению
   */
  showNextMessage = () => {
    const {showMessageNumber} = this.state;
    const messageId = this.state.searchMessagesIds[showMessageNumber - 2];
    this.setState({showMessageNumber: showMessageNumber - 1});
    this.loadMessageLogic(messageId, 'down');
  }
  
  /**
   * Проверка на необходимость подгрузки сообщений или переход к существующему
   * @param messageId
   * @param direction
   */
  loadMessageLogic = (messageId, direction) => {
    if (this.state.messagesIds.includes(messageId)) {
      this.props.onScroll(messageId);
    } else {
      this.loadPrevMessages(messageId, direction);
    }
  }
  
  loadPrevMessages = (messageId, direction) => {
    services
      .messageSubscription
      .loadPrevMessageHistory(messageId)
      .then(() => {
        setTimeout(() => {
          this.props.onScroll(messageId, direction);
        }, 100)
      })
  }
  
  /**
   * Закрытие окна с поиском
   */
  handleCloseSearch = () => {
    this.clearSearchResult();
    this.props.onClose();
    this.setState({openState: false});
  }
  
  render() {
    const {className, overrideClassNames, show} = this.props;
    const {searchText} = this.state;
    const styles = mergeClassNames(originalStyles, overrideClassNames);
    const {showMessageNumber, totalMessageCount} = this.state;
    const disabledPrevBtn = !(totalMessageCount && showMessageNumber < totalMessageCount);
    const disabledNextBtn = !(totalMessageCount && showMessageNumber > 1);
    
    return (
      <div className={cn({
        [className]: !!className,
        [styles.searchWrapperClose]: !show,
        [styles.searchWrapper]: true,
      })}>
        {/* Отображение количества результатов поиска будет реализовано позже */}
        {/*{!!totalMessageCount && (<div>*/}
        {/*  {showMessageNumber} / {totalMessageCount}*/}
        {/*</div>)}*/}
        <div className={cn(styles.form)}>
          <input
            ref={this.input}
            type="text"
            className={cn(styles.input)}
            value={searchText}
            placeholder="Поиск"
            onKeyDown={this.keyPress}
            onChange={this.handleChange}/>
          <div className={cn(styles.buttonsGroup)}>
            <button
              className={cn(styles.button, styles.buttonPrev)}
              onClick={this.showPrevMessage}
              disabled={disabledPrevBtn}
            >
              <svg width="15" height="8" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M1.156 6.89a.523.523 0 0 0-.125.173.583.583 0 0 0 .032.484c.046.078.109.14.187.187.083.047.174.07.273.07.167 0 .295-.049.383-.148l5.938-6.234h-.688l5.93 6.234a.518.518 0 0 0 .383.149.521.521 0 0 0 .46-.258.481.481 0 0 0 .079-.274.5.5 0 0 0-.164-.375L7.922.664a.67.67 0 0 0-.195-.148A.5.5 0 0 0 7.5.46a.556.556 0 0 0-.422.195L1.156 6.891Z" fill="currentColor"/></svg>
              <span>Предыдущий</span>
            </button>
            <button
              className={cn(styles.button, styles.buttonNext)}
              onClick={this.showNextMessage}
              disabled={disabledNextBtn}
            >
              <span>Следующий</span>
              <svg width="15" height="9" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.5 8.29a.57.57 0 0 0 .227-.048.67.67 0 0 0 .195-.148l5.922-6.242a.516.516 0 0 0 .086-.649.52.52 0 0 0-.188-.195.521.521 0 0 0-.273-.07.538.538 0 0 0-.383.156l-5.93 6.234h.688L1.906 1.094a.504.504 0 0 0-.383-.157.548.548 0 0 0-.273.07.548.548 0 0 0-.258.469c0 .079.013.149.04.212a.66.66 0 0 0 .124.171l5.922 6.235c.13.13.271.195.422.195Z" fill="currentColor"/></svg>
            </button>
          </div>
        </div>
        <button className={cn(styles.buttonClose)} onClick={this.handleCloseSearch}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 20a10 10 0 0 0 9.2-13.9A10.2 10.2 0 0 0 10 0a9.6 9.6 0 0 0-7 3C2 3.9 1.2 5 .7 6a9.7 9.7 0 0 0 2.2 11 10.2 10.2 0 0 0 7 2.9Zm0-1.3a8.5 8.5 0 0 1-6.2-2.5A8.8 8.8 0 0 1 1.3 10a8.6 8.6 0 0 1 2.5-6.2A8.6 8.6 0 0 1 10 1.3a8.5 8.5 0 0 1 6.2 2.5 8.7 8.7 0 0 1-6.2 15Zm-3.5-4.6c.2 0 .4 0 .5-.2l3-3 3 3a.6.6 0 0 0 1 0l.1-.4c0-.2 0-.3-.2-.5l-3-3 3-3 .2-.5c0-.2 0-.3-.2-.4a.6.6 0 0 0-.4-.2c-.2 0-.3 0-.5.2l-3 3-3-3a.6.6 0 0 0-.5-.2c-.2 0-.3 0-.4.2l-.2.4c0 .2 0 .3.2.5l3 3-3 3-.2.5c0 .2 0 .3.2.4.1.2.2.2.4.2Z" fill="currentColor"/></svg>
          <span>Закрыть</span>
        </button>
      </div>
    );
  }
}
